import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

export const ButtonLoader = styled(CircularProgress)`
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ theme }) =>
    `${theme.spacing(5)} ${theme.spacing(6)} ${theme.spacing(3)}`};
`;

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Body = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const TextField = styled.div`
  padding: ${({ theme }) => `${theme.spacing(4)}`};
  min-height: 12rem;

  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme }) => theme.palette.background.paper};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;

  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
`;
